var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./DemandProbeshnaryNote.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-685c9bc3!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./DemandProbeshnaryNote.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/components/DemandProbeshnaryNote.vue
// module id = 48
// module chunks = 0